export const initialState: BugShowState = {
  selectedBugId: undefined,
  severities: [],
  status: [],
  tags: [],
  replicabilities: [],
  bugTypes: [],
  selectedSeverity: undefined,
  selectedStatus: undefined,
  selectedTags: undefined,
  selectedReplicability: undefined,
  selectedBugType: undefined,
  isLoading: false,
};

export default (state = initialState, action: BugShowActions): BugShowState => {
  switch (action.type) {
    case "bugShow/setSelectedBug":
      return {
        ...state,
        selectedBugId: action.payload,
      };
    case "bugShow/setSeverities":
      return {
        ...state,
        severities: action.payload,
      };
    case "bugShow/setStatus":
      return {
        ...state,
        status: action.payload,
      };
    case "bugShow/setTags":
      return {
        ...state,
        tags: action.payload,
      };
    case "bugShow/setSelectedSeverity":
      return {
        ...state,
        selectedSeverity: action.payload,
      };
    case "bugShow/setSelectedStatus":
      return {
        ...state,
        selectedStatus: action.payload,
      };
    case "bugShow/setSelectedTags":
      return {
        ...state,
        selectedTags: action.payload,
      };
    case "bugShow/setReplicabilities":
      return {
        ...state,
        replicabilities: action.payload,
      };
    case "bugShow/setSelectedReplicability":
      return {
        ...state,
        selectedReplicability: action.payload,
      };
    case "bugShow/setBugTypes":
      return {
        ...state,
        bugTypes: action.payload,
      };
    case "bugShow/setSelectedBugType":
      return {
        ...state,
        selectedBugType: action.payload,
      };
    case "bugShow/setIsLoading":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "bugShow/setSearch":
      return {
        ...state,
        search: action.payload,
      };
    default:
      return state;
  }
};
